// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-P":"P_power-ocean-home-P__v257V"};